import React from 'react';
import Dropzone from "react-dropzone";
// Import React FilePond
import { FilePond, registerPlugin } from 'react-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

function DropFile({ handleUpload = () => {}, size='lg', message=''  }) {
  async function handleAcceptedFiles(files) {
    handleUpload(files);
  }

  return (
    <React.Fragment>
      <Dropzone
        onDrop={async acceptedFiles => {
           await handleAcceptedFiles(acceptedFiles);
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div className={`dropzone dropzone-${size} w-100 h-100 dz-clickable d-flex align-items-center`}>
            <div
              className="dz-message needsclick m-0"
              {...getRootProps()}
            >
              <div className="mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
                  <g id="upload-cloud">
                    <path id="Shape" d="M0,0H56V56H0Z" fill="none" />
                    <path id="Shape-2" data-name="Shape" d="M25.683,0A16.336,16.336,0,0,1,41.909,14.453a12.833,12.833,0,0,1-2.224,25.163l0-4.615a14,14,0,0,0-27.991-.525L11.683,35v4.615A12.833,12.833,0,0,1,9.457,14.453,16.333,16.333,0,0,1,25.683,0Z" transform="translate(2.317 4.666)" fill="#94F956" />
                  </g>
                  <path id="Shape_path" data-name="Shape path" d="M9.9,0l9.9,9.9-3.3,3.3L12.234,8.934V21.966H7.567V8.93L3.3,13.2,0,9.9,9.9,0Z" transform="translate(18.098 29.367)" fill="#030541" />
                </svg>
              </div>
              <h4>{message}</h4>
            </div>
          </div>
        )}
      </Dropzone>
    </React.Fragment>
  )
}

export default DropFile
